import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Box,
} from '@mui/material';
import React from 'react';

function SkeletonChart({ 
  title = true,
  height = 300,
  type = 'line', // 'line', 'bar', 'pie'
  ...props 
}) {
  const renderChartSkeleton = () => {
    switch (type) {
      case 'pie':
        return (
          <Box display="flex" justifyContent="center" alignItems="center" height={height}>
            <Skeleton variant="circular" width={height * 0.8} height={height * 0.8} />
          </Box>
        );
      case 'bar':
        return (
          <Box display="flex" alignItems="end" justifyContent="space-around" height={height} p={2}>
            {Array.from({ length: 6 }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width={40}
                height={Math.random() * (height - 50) + 50}
              />
            ))}
          </Box>
        );
      default: // line
        return (
          <Box position="relative" height={height} p={2}>
            <Skeleton variant="rectangular" width="100%" height="100%" />
            {/* 라인 차트의 점들을 시뮬레이션 */}
            <Box position="absolute" top={0} left={0} right={0} bottom={0} p={2}>
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="circular"
                  width={8}
                  height={8}
                  sx={{
                    position: 'absolute',
                    top: `${20 + Math.random() * 60}%`,
                    left: `${10 + index * 20}%`,
                  }}
                />
              ))}
            </Box>
          </Box>
        );
    }
  };

  return (
    <Card {...props}>
      {title && (
        <CardHeader
          title={<Skeleton variant="text" width="40%" />}
          action={<Skeleton variant="circular" width={24} height={24} />}
        />
      )}
      <CardContent>
        {renderChartSkeleton()}
        
        {/* 범례 시뮬레이션 */}
        {type !== 'line' && (
          <Box display="flex" justifyContent="center" flexWrap="wrap" mt={2} gap={2}>
            {Array.from({ length: type === 'pie' ? 4 : 3 }).map((_, index) => (
              <Box key={index} display="flex" alignItems="center">
                <Skeleton variant="rectangular" width={12} height={12} sx={{ mr: 1 }} />
                <Skeleton variant="text" width={60} />
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default SkeletonChart;